/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MonthlyOrdinal = {
    First: 'First',
    Second: 'Second',
    Third: 'Third',
    Last: 'Last'
} as const;
export type MonthlyOrdinal = typeof MonthlyOrdinal[keyof typeof MonthlyOrdinal];


export function instanceOfMonthlyOrdinal(value: any): boolean {
    for (const key in MonthlyOrdinal) {
        if (Object.prototype.hasOwnProperty.call(MonthlyOrdinal, key)) {
            if (MonthlyOrdinal[key as keyof typeof MonthlyOrdinal] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MonthlyOrdinalFromJSON(json: any): MonthlyOrdinal {
    return MonthlyOrdinalFromJSONTyped(json, false);
}

export function MonthlyOrdinalFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonthlyOrdinal {
    return json as MonthlyOrdinal;
}

export function MonthlyOrdinalToJSON(value?: MonthlyOrdinal | null): any {
    return value as any;
}

export function MonthlyOrdinalToJSONTyped(value: any, ignoreDiscriminator: boolean): MonthlyOrdinal {
    return value as MonthlyOrdinal;
}

